import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useStoreUnit, StoreUnit } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<StoreUnit>
    useData={useStoreUnit}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
